module.exports = __webpack_public_path__ + "static/media/banner.9ca8b268.jpg";